import type { ReactNode } from 'react';
import { Button } from '../ui/Button/Button';
import type { WindowInstance } from './types';
import { WINDOW_DEFINITIONS } from './windowRegistry';

interface WindowFrameProps {
  window: WindowInstance;
  children: ReactNode;
  onClose: (id: string) => void;
}

export function WindowFrame({ window, children, onClose }: WindowFrameProps) {
  const definition = WINDOW_DEFINITIONS[window.kind];

  return (
    <section className="terminal-window">
      <header className="terminal-window__header" title="Drag window">
        <div className="terminal-window__title">
          <span className="terminal-window__badge">{definition.icon}</span>
          <span>{window.title}</span>
        </div>
        <div className="terminal-window__actions no-window-drag">
          <Button variant="ghost" onClick={() => onClose(window.id)} aria-label={`Close ${window.title}`}>×</Button>
        </div>
      </header>
      <div className="terminal-window__body">{children}</div>
    </section>
  );
}
